import { render, staticRenderFns } from "./DeliveryFirstAmtDetail.vue?vue&type=template&id=a6e65d12&"
import script from "./DeliveryFirstAmtDetail.vue?vue&type=script&lang=ts&"
export * from "./DeliveryFirstAmtDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports